import C4 from "../../assets/images/webisteimage/c4.jpg";
import C1 from "../../assets/images/webisteimage/c1.jpg";

export const Fleetconfig = {
  head: "Fleet Workshop ",
  desc: `Our workshop is equipped with skilled and experienced personnel capable of precisely understanding your needs. They are committed to lighten all kinds of issues you encounter with your vehicles, no matter how much complex they seem.
    Our team is vibrant, dedicated, well trained and do the task "First Time Right" Our technicians have the complete skill set to carry out every sort of repairing works. We also have advanced tools, technologies, machinery & an ERP system that guarantee quality service.
    Waiting time is minimum as we have enough and more resources to ensure the repairing works are completed within shortest turnaround time.`,
  imageUrl: C4,
};
export const Satistconfig = {
  head: "Committed to customer satisfaction ",
  desc: `Aiming complete satisfaction to customers is our immediate and ultimate gool. We strive to achieve it via all ethical ways through persistent effort backed by proper planning and getting the job dons, with precise trouble shoung and wing orily the required spareparts.`,
  imageUrl: C1,
};

export const Expertconfig = {
  heading: "Committed to customer satisfaction",
  bulletPoints: [
    "MECHANICAL WORKS",
    "VEHICLE WASHING",
    "ELECTRICAL AND AIR CONDITIONING",
    "RTA PASSING WORKS",
    "PERIODIC MAINTANENCE SERVICE",
    "BUS UPHOLSTERY",
    "QUICK OIL CHANGE AND LUBRICATION SERVICE",
    "WINDOW TINTING",
    "WATER SERVICE - SHAMPOO AND GREASING",
    "STICKER 108S",
    "SCHOOL BUS MODIFICATION WORKS AS PER RTA SPECIFICATION",
    "SEAT MODIFICATION",
  ],
  paragraph:
    "We use only genuine guaranteed and warranteed spareparts. Annual Service contract package for fleet customers",
};
